import { useQuery } from 'data-fetching-client';
import { GET_IN_APP_CURRENCIES, GET_PUBLIC_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { isCountryCodeString, isCurrencyCodeString } from 'pricing-pages-api/currency/types';
import { useGetCurrencyStore, useSetCurrencyStore } from '../context/CurrencyContext';
import { useSetOneGlobalLoadingState } from '../context/GlobalLoadingStateContext';
import { getBrowserLocale } from '../utils/getBrowserLocale';
const UseSetLoadingCurrencyComplete = () => {
  const loadingCompletedCallback = useSetOneGlobalLoadingState('Currencies');
  const setStore = useSetCurrencyStore();
  const handleCurrencyFetchCompleted = ({
    currencies
  }) => {
    setStore(currencies);
    loadingCompletedCallback();
  };
  return handleCurrencyFetchCompleted;
};
export const useInAppCurrencies = () => {
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_IN_APP_CURRENCIES, {
    variables: {},
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePublicCurrencies = () => {
  const {
    browserLocale,
    preferredCountryCode
  } = getBrowserLocale();
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();

  // Validate preferredCountryCode before passing to backend
  const validatedCountryCode = isCountryCodeString(preferredCountryCode) ? preferredCountryCode : undefined;
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_CURRENCIES, {
    variables: {
      browserLocale,
      preferredCountryCode: validatedCountryCode
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePricingPageCurrencies = ({
  isAppAuth
}) => {
  const queryHookToUse = isAppAuth ? useInAppCurrencies : usePublicCurrencies;
  return queryHookToUse();
};
export const useDisplayedCurrencyCode = () => {
  const displayedCurrencyCode = useGetCurrencyStore(store => store.displayedCurrencyCode);
  const defaultCurrencyCode = useGetCurrencyStore(store => store.defaultCurrencyCode);

  // Validate and fallback to portal's default currency if invalid
  if (isCurrencyCodeString(displayedCurrencyCode)) {
    return displayedCurrencyCode;
  }
  return defaultCurrencyCode;
};
export const useLockedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.lockedCurrencyCode);

  // Validate and return undefined if invalid
  if (isCurrencyCodeString(currencyCode)) {
    return currencyCode;
  }
  return undefined;
};
export const useCurrencyCodeUnitToDisplay = () => {
  const currencyCodeUnit = useGetCurrencyStore(store => store.currencyCodeUnit);
  const showCurrencyCodeUnit = useGetCurrencyStore(store => store.showCurrencyCodeUnit);
  return showCurrencyCodeUnit ? currencyCodeUnit : undefined;
};
export const useAvailableCurrencyCodes = () => {
  const availableCurrencyCodes = useGetCurrencyStore(store => store.availableCurrencyCodes);

  // Filter out any invalid currency codes
  if (Array.isArray(availableCurrencyCodes)) {
    return availableCurrencyCodes.filter(isCurrencyCodeString);
  }
  return [];
};

//  countryCode?: string | null | undefined;
export const useCountryCode = () => {
  const countryCode = useGetCurrencyStore(store => store.countryCode);
  return countryCode;
};